import type { IRouteRecords } from './types';

// !important - this file should be used only for routes settings
// !important - Please add a type for each route in src/@/_navigation/types.ts before creating a new route

const Routes: IRouteRecords = {
  MAIN: { name: 'MAIN', link: '/' },

  /**
   * Bridge Plan Routes
   */

  TEST: {
    name: 'TEST',
    link: '/test',
    backLink: 'MAIN',
  },

  BRIDGE_PLAN: {
    name: 'MAIN',
    link: '/bridge-plan',
    backLink: 'MAIN',
    params: '/:lead_id',
  },

  COLLEGE_INFO: {
    name: 'COLLEGE_INFO',
    link: '/bridge-plan/college-info',
    backLink: 'MAIN',
    params: '/:lead_id/:college_id',
  },

  COLLEGE_REQ: {
    name: 'COLLEGE_REQ',
    link: '/bridge-plan/college-requirements',
    backLink: 'MAIN',
    params: '/:lead_id/:college_id',
  },

  COLLEGE_PROG_REQ: {
    name: 'COLLEGE_PROG_REQ',
    link: '/bridge-plan/college-program-requirements',
    backLink: 'MAIN',
    params: '/:lead_id/:college_id',
  },

  INVESTMENT: {
    name: 'INVESTMENT',
    link: '/bridge-plan/investment',
    backLink: 'MAIN',
    params: '/:lead_id',
  },

  PAYMENT_OPTIONS: {
    name: 'PAYMENT_OPTIONS',
    link: '/bridge-plan/payment-options',
    backLink: 'INVESTMENT',
    params: '/:lead_id',
  },

  INFO: {
    name: 'INFO',
    link: '/bridge-plan/customer-info',
    backLink: 'MAIN',
    params: '/:lead_id',
  },

  PAYMENT_METHODS: {
    name: 'PAYMENT_METHODS',
    link: '/bridge-plan/payment-method',
    backLink: 'MAIN',
    params: '/:lead_id',
  },

  COMPLETE_ORDER: {
    name: 'COMPLETE_ORDER',
    link: '/bridge-plan/complete-order',
    backLink: 'MAIN',
    params: '/:lead_id',
  },

  CHECKOUT: {
    name: 'CHECKOUT',
    link: '/bridge-plan/checkout',
    backLink: 'INVESTMENT',
    params: '/:lead_id',
  },

  UPDATE: {
    name: 'UPDATE',
    link: '/bridge-plan/update',
    backLink: 'PAYMENT_OPTIONS',
    params: '/:lead_id',
  },

  SUCCESS: {
    name: 'SUCCESS',
    link: '/bridge-plan/success',
    backLink: 'CHECKOUT',
    params: '/:lead_id',
  },

  CLIMB_SUCCESS: {
    name: 'CLIMB_SUCCESS',
    link: '/bridge-plan/climb-success',
    backLink: 'CHECKOUT',
    params: '/:lead_id',
  },

  CONSENT: {
    name: 'CONSENT',
    link: '/bridge-plan/consent',
    backLink: 'MAIN',
    params: '/:lead_id',
  },

  TERMS: {
    name: 'TERMS',
    link: '/bridge-plan/terms',
    backLink: 'TERMS',
    params: '/:lead_id',
  },
};

export default Routes;
